import border from './border';
import color from './color';
import elevation from './elevation';
import flex from './flex';
import grid from './grid';
import misc from './misc';
import position from './position';
import size from './size';
import space from './space';
import stroke from './stroke';
import transform from './transform';
import typography from './typography';
export default [grid, flex, position, size, space, border, stroke, typography, color, elevation, transform, misc];